import { StyleSheet, View } from 'react-native'
import { Card } from 'react-native-paper'
import { useTheme } from '../../../hooks/theme.hook'

export const MelddCard = ({
  children,
  title,
  actions,
  header,
}: {
  children: React.ReactNode
  title?: string
  header?: React.ReactNode
  actions?: React.ReactNode[] | React.ReactNode
}) => {
  const { colors } = useTheme()
  return (
    <Card
      style={{
        flex: 1,
        height: 1, // To trigger the flex on iOS
        flexDirection: 'column',
      }}
      elevation={5}
      mode={'elevated'}
      contentStyle={{ flex: 1 }}
    >
      {title && <Card.Title title={title} />}
      {header && <View>{header}</View>}
      <Card.Content
        style={{
          backgroundColor: colors.surface,
          flex: 1,
          paddingHorizontal: 0,
          margin: 0,
        }}
      >
        {children}
      </Card.Content>
      {<Card.Actions>{actions}</Card.Actions>}
    </Card>
  )
}
